import React from 'react'
import { TextField, RaisedButton } from 'material-ui';
import { cyan900 } from 'material-ui/styles/colors';

const SageInfo = ({ sageId }) => {
  const sageLink = sageId ? `https://myphoto.mycloudatwork.com/syracuse-main/html/main.html?url=https://myphoto.mycloudatwork.com/sdata/x3/erp/PILOT/SORDER('${sageId}')?representation=SORDER.$details` : null
  const styles = {
    floatingLabelStyle: {
      color: cyan900,
    },
    inputStyle: {
      marginRight: '4%',
      width: '250px',
    },
  };
  return (
    <div className="sage-info-container" style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
      <TextField
        floatingLabelText="Sage Id"
        floatingLabelStyle={styles.floatingLabelStyle}
        floatingLabelFixed={true}
        value={sageId}
        name="sageId"
        disabled
        style={styles.inputStyle}
      />
      <a href={sageLink} target="_blank">
        <RaisedButton
          label="Sage Link"
          style={{ marginBottom: '20px', marginRight: '10px' }}
          primary
        />
      </a>
    </div>
  )
}

export default SageInfo


// WEBPACK FOOTER //
// ./src/components/orders/Common/SageInfo.js